<div class="condensed-full-header-wrapper">
  <div>
    <div class="detailview-image">
      <div
        class="image-border"
        miq-bg-image
        [secureImage]="
          reportRecordDataLocal
            | reportFieldFormatter
              : { templateId: currentView().templateId, field: imageField, joinString: true, onlyUrl: false }
            | async
        "
      ></div>
    </div>

    <div class="secondary-images">
      @if (!hasAdditionalImage) {
        <div class="additional-image-block">
          <div>
            <mat-icon svgIcon="add-icon"></mat-icon>
            <span (click)="addImage()">{{ 'recordPPT.addImage' | translate }}</span>
          </div>
        </div>
      } @else {
        <div class="image">
          <div class="actions">
            <mat-icon svgIcon="edit-icon" (click)="editImage(0)"></mat-icon>
            <mat-icon svgIcon="delete" (click)="deleteImage(0)"></mat-icon>
          </div>
          <div
            class="with-additional-image"
            miq-bg-image
            [secureImage]="
              reportRecordData()
                | reportFieldFormatter
                  : {
                      templateId: currentView().templateId,
                      field: additionalImageField,
                      joinString: true,
                      onlyUrl: false,
                    }
                | async
            "
        ></div>
      </div>
    }

    @if (!hasSecondaryImage) {
      <div class="additional-image-block">
        <div>
          <mat-icon svgIcon="add-icon"></mat-icon>
          <span (click)="addImage()">{{ 'recordPPT.addImage' | translate }}</span>
        </div>
      </div>
    } @else {
      <div class="image">
        <div class="actions">
          <mat-icon svgIcon="edit-icon" (click)="editImage(1)"></mat-icon>
          <mat-icon svgIcon="delete" (click)="deleteImage(1)"></mat-icon>
        </div>
        <div
          class="with-additional-image"
          miq-bg-image
            [secureImage]="
              reportRecordData()
                | reportFieldFormatter
                  : {
                      templateId: currentView().templateId,
                      field: secondaryImageField,
                      joinString: true,
                      onlyUrl: false,
                    }
                | async
            "
      ></div>
    </div>
  }
</div>
<div class="reset-images">
  <mat-icon svgIcon="refresh" aria-hidden="false"></mat-icon>
  <span (click)="resetImages()">{{ 'recordPPT.resetImages' | translate }}</span>
</div>
</div>
</div>
